export function addPickMySolar(){
    var pkms = document.createElement("script");
    pkms.type = "text/javascript"; 
    pkms.async = true;
    pkms.src = "//codebase.pickmysolar.com/v2/pms.js";
    pkms.setAttribute("pid","2aef35139637eb01e60296f58a37239c");
    document.getElementsByTagName("head")[0].appendChild(pkms);
}